<script setup>
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
    type: {
        type: String,
        default: 'info',
    },
    href: {
        type: String,
        required: true,
    },
});

const isExternal = computed(() => {
    try {
        const link = new URL(props.href);

        return link.origin !== window.location.origin;
    } catch {
        return false;
    }
});
</script>

<template>
    <component
        :is="isExternal ? 'a' : Link"
        class="alert-btn"
        :class="{
            'alert-btn-success': type === 'success',
            'alert-btn-info': type === 'info',
            'alert-btn-warning': type === 'warning',
            'alert-btn-error': type === 'error',
        }"
        :href="href"
        :target="isExternal ? '_blank' : undefined"
    >
        <slot />
    </component>
</template>
